"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.pinTypeOfRank = exports.extraFromRank = exports.rankOf = exports.extraOf = exports.matches = exports.knownModels = void 0;
const effect_1 = require("effect");
const Class = __importStar(require("../class"));
const derive_1 = require("./derive");
const row_1 = require("./row");
// Like the device query, so a row with a model from a newer domain version stays off the map.
exports.knownModels = new Set(effect_1.Record.keys(Class.models));
const percentOf = (row, include) => {
    switch (include) {
        case 'FilterStatus':
            return row.pf;
        case 'Co2Status':
            return row.pc;
        case 'EnhancementsStatus':
            return row.pe;
        default:
            return undefined;
    }
};
const listed = (list, value) => list.length === 0 || (value !== null && list.includes(value));
const connectionOf = (cf) => {
    if (cf === null)
        return null;
    return cf === 1 ? 'connected' : 'disconnected';
};
const alarmsMatch = (row, q) => {
    const tags = row.al ?? [];
    if (q.alarmTypes.length > 0 && !tags.some(tag => q.alarmTypes.includes(tag)))
        return false;
    if (q.alarmSeverities.length === 0)
        return true;
    const severity = (0, derive_1.worstSeverityOfTags)(tags);
    return severity !== 'none' && q.alarmSeverities.includes(severity);
};
const levelMatches = (row, q) => {
    if ((0, derive_1.consumableCategoryOf)(q.include) === null)
        return true;
    const pct = percentOf(row, q.include);
    return !(pct === undefined || pct < q.consumableLevelMin || pct > q.consumableLevelMax);
};
// The reference predicate: any faster columnar implementation must agree with it.
const matches = (row, q, scope, nowMs) => {
    if (!exports.knownModels.has(row.m) || !(0, row_1.isVisible)(row, nowMs))
        return false;
    if (scope._tag === 'Only' && !scope.tenantIds.has(row.t))
        return false;
    if (q.ring !== undefined && row.r !== q.ring)
        return false;
    return (listed(q.model, row.m) &&
        listed(q.connectionState, connectionOf(row.cf)) &&
        listed(q.operatingMode, row.om) &&
        listed(q.installationStatus, row.is) &&
        alarmsMatch(row, q) &&
        levelMatches(row, q));
};
exports.matches = matches;
const extraOf = (row, include) => {
    switch (include) {
        case 'ConnectionState':
            return row.on === 1 ? 'connected' : 'disconnected';
        case 'Alarms':
            return (0, derive_1.worstSeverityOfTags)(row.al ?? []);
        default:
            return (0, derive_1.toFillCondition)(percentOf(row, include) ?? 100);
    }
};
exports.extraOf = extraOf;
const ranks = {
    ConnectionState: { connected: 0, disconnected: 2 },
    Alarms: { 'none': 0, 'non-critical': 1, 'critical': 2 },
    FilterStatus: { ok: 0, warning: 1, critical: 2 },
    Co2Status: { ok: 0, warning: 1, critical: 2 },
    EnhancementsStatus: { ok: 0, warning: 1, critical: 2 },
};
const extras = {
    // Connection state has no middle rank; a cluster of connected and disconnected devices is 2.
    ConnectionState: ['connected', 'disconnected', 'disconnected'],
    Alarms: ['none', 'non-critical', 'critical'],
    FilterStatus: ['ok', 'warning', 'critical'],
    Co2Status: ['ok', 'warning', 'critical'],
    EnhancementsStatus: ['ok', 'warning', 'critical'],
};
const rankOf = (include, extra) => ranks[include][extra] ?? 0;
exports.rankOf = rankOf;
const extraFromRank = (include, rank) => extras[include][rank];
exports.extraFromRank = extraFromRank;
const pinTypeOfRank = (rank) => {
    if (rank === 0)
        return 'ok';
    return rank === 1 ? 'warning' : 'error';
};
exports.pinTypeOfRank = pinTypeOfRank;
//# sourceMappingURL=filter.js.map